export default function admin() {

}